import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as Actions from "../../store/actions"

const Redux = (PassedComponent) => {

	const mapStateToProps = ({ user, navigation, rule, dataModels }) => {
		console.log("businessRule ???", rule);
		console.log("dataModels==", dataModels);
		return {
			user: user,
			navigation: navigation,
			rules: rule,
			dataModels: dataModels
		}
	}

	const mapDispatchToProps = {
		getBusinessRule: Actions.getBusinessRule,
		saveBusinessRule: Actions.saveBusinessRule,
		newBusinessRule: Actions.newBusinessRule,
		updateBusinessRule: Actions.updateBusinessRule,
		getDataModels: Actions.getDataModels,
		// showAlert: Actions.showAlert
	}

	return connect(mapStateToProps, mapDispatchToProps)(
		({ ...props }) =>
			<PassedComponent {...props} />
	)
}

export default Redux